import { Colors, Fonts } from '@lerna-whitelabel/styles'

export default {
  palette: {
    primary: {
      main: '#ffc302'
    },
    secondary: {
      // main: Colors.secondary,
      // contrastText: Colors.primary
      main: '#121212',
      contrastText: '#ffc302'
    }
  },
  typography: {
    useNextVariants: true,
    // Use the system font instead of the default Roboto font.
    fontFamily: "'Josefin Sans', sans-serif",
    fontWeight: Fonts.fontWeight.regular,
    color: Colors.text
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'unset'
      }
    },
    MuiTooltip: {
      popper: {
        zIndex: 5000
      },
      tooltip: {
        margin: '3px !important',
        backgroundColor: Colors.primary,
        color: Colors.white,
        border: `1px solid ${ Colors.blue[1] }`,
        fontSize: 12,
        letterSpacing: 1
      }
    },
    MuiCard: {
      root: {
      }
    },
    MuiFab: {
      extended: {
        padding: '0 25px'
      }
    }
  }
}
